'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _components = require('../../components');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./Home.css');

var Home = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);
    return (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this));
  }

  (0, _createClass3.default)(Home, [{
    key: 'render',
    value: function render() {
      // images
      var foeLogo = require('../../../static/images/img-foe-logo.png');
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      var orangutanImg = require('../../../static/images/young-orangutan.jpg');

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-dimmer' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'banner-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-card' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'banner-title' },
                    'Are you invested in deforestation and climate change?'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'banner-tagline' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'banner-tagline-span' },
                      'Every year, the world loses an area of tropical rainforest the size of the United Kingdom.'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'banner-tagline' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'banner-tagline-span' },
                      'Find sustainable, deforestation-free investment options. Move your money. That\'s your power.'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'banner-btn-wrap' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.clean,
                        bigbutton: true,
                        title: 'Top-scoring funds' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Top-scoring funds',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'banner-logos-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'banner-logos-copy' },
                      'A project of'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'banner-logos' },
                      _react2.default.createElement('img', {
                        src: aysLogo,
                        alt: 'As You Sow',
                        styleName: 'banner-logo-ays'
                      }),
                      _react2.default.createElement(
                        _components.SrOnly,
                        null,
                        'As You Sow'
                      ),
                      _react2.default.createElement('img', {
                        src: foeLogo,
                        alt: 'Friends of the Earth',
                        styleName: 'banner-logo-foe'
                      }),
                      _react2.default.createElement(
                        _components.SrOnly,
                        null,
                        'Friends of the Earth'
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'autocomplete-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'autocomplete-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'autocomplete-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'autocomplete-card' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'autocomplete-title' },
                  'Search your savings for investments in deforestation.'
                ),
                _react2.default.createElement(_components.AutocompleteSearch, null),
                _react2.default.createElement(
                  'div',
                  { styleName: 'autocomplete-link' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.clean,
                      title: 'Search funds | Deforestation Free Funds',
                      xstrong: true
                    },
                    'View funds list',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'autocomplete-subtitle' },
                  'We have 3,000 of the most popular mutual funds and ETFs in our database, including dozens of sustainable, deforestation-free options.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'x-401k' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-401k-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'media-react-player-wrap-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'media-react-player-wrap' },
                _react2.default.createElement(_reactPlayer2.default, {
                  url: 'https://vimeo.com/433644374',
                  volume: 0.5
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-401k-title' },
              'Invest your values'
            ),
            _react2.default.createElement('img', { src: orangutanImg, alt: 'Young orangutan', styleName: 'orangutan-image' }),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation and degradation of vast swaths of land for commodities such as palm oil, pulp and paper, cattle, soy, timber, and rubber is responsible for almost one quarter of all global greenhouse gas emissions and for unprecedented species extinction.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Simultaneously, the occupation of vast areas of land for industrial plantation agriculture is a leading cause of violent land conflicts due to its frequent dispossession and displacement of local and indigenous communities.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Simply put, if we want to limit the catastrophic impacts of climate change, reduce our impact on the world\u2019s biodiversity, and respect the rights of indigenous peoples, protecting the world\u2019s remaining forests is key.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation isn\u2019t just bad for the planet. Increasingly, it\u2019s risky business. Companies engaged in deforestation, land grabbing and human rights violations expose themselves and their shareholders to significant financial risks from stalled business operations, reputational damage, and legal liabilities.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The industries that drive most deforestation, especially in the tropics, are palm oil, paper/pulp, rubber, timber, cattle, and soy. If it were up to you, your money probably wouldn\u2019t be invested in these industries. But would you know it if it was? Your answer matters, because as Bill McKibben has said, ',
              _react2.default.createElement(
                'strong',
                null,
                '"if it\'s wrong to wreck the planet, then it\'s wrong to profit from that wreckage."'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation Free Funds can help get your money out of deforestation.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation Free Funds is a search platform that informs and empowers everyday people, consumers, and investors to make decisions aligned with their values. It lets you see if your savings are invested in companies and sectors driving deforestation, shows you how to take action to get fund managers to implement more sustainable investment policies, and helps you find investment options that support an environmentally-friendly future.'
            )
          )
        ),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(_components.DeforestationSectors, null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.BenchmarkGrid, null),
        _react2.default.createElement(_components.TargetDateGrid, null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.FamilyGrid, null),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return Home;
}(_react.Component)) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1323
// module chunks = 0